export interface ReviewProgress {
  reviewed: number;
  total: number;
}

export const zeroReviewProgress = {reviewed: 0, total: 0} as ReviewProgress;
